import {debounce} from 'lodash';

export default class VH {

  constructor() {
    this.setVH();
    this._bindEvents();
  }

  _bindEvents() {
    let debounced = _.debounce(this.setVH.bind(this), 200);
    window.addEventListener('resize', debounced);
    window.addEventListener('popstate', debounced.cancel);
  }

  setVH() {
    this.vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${this.vh}px`);
  }
}
